import {
  STATUS_NOT_REQUESTED,
  STATUS_LOADING,
  STATUS_SUCCESS,
  STATUS_ERROR,
} from '../../../const';
import {
  HELP_REQUEST,
  HELP_REQUEST_ERROR,
  HELP_REQUEST_SUCCESS,
} from '../actions';

const initialState = {
  status: STATUS_NOT_REQUESTED,
  error: {},
};

export const requestHelp = (state = initialState, action) => {
  switch (action.type) {
    case HELP_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        error: initialState.error,
      };

    case HELP_REQUEST_SUCCESS:
      return {
        ...state,
        status: STATUS_SUCCESS,
      };

    case HELP_REQUEST_ERROR:
      return {
        ...state,
        status: STATUS_ERROR,
        error: action.payload.error,
      };

    default:
      return state;
  }
};
